import Vue from 'vue';

// 原始票据类型
Vue.filter('originType', function (val) {
  switch (val) {
    case '10100':
      return '增值税专用发票'
    case '10101':
      return '增值税普通发票'
    case '10102':
      return '增值税电子普通发票'
    case '10103':
      return '增值税普通发票(卷票)'
    case '10104':
      return '机动车销售统一发票'
    case '10105':
      return '二手车销售统一发票'
    case '10107':
      return '电子发票（增值税专用发票）'
    case '10108':
      return '电子发票（普通发票）'
    case '10200':
      return '定额发票'
    case '10400':
      return '机打发票'
    case '10500':
      return '出租车发票'
    case '10503':
      return '火车票'
    case '10505':
      return '客运汽车'
    case '10506':
      return '航空运输电子客票行程单'
    case '10507':
      return '过路费发票'
    case '10508':
      return '网约车行程单'
    case '10900':
      return '可报销其他发票'
    case '20100':
      return '国际小票'
    case '10902':
      return '完税证明'
    case '10505a':
      return '船票'
    case '10100/10101/10102':
      return '区块链发票'
  }
});
